module.exports = __webpack_public_path__ + "static/media/category-1.4b557bf1.png";